export const content = [
    {
        title: 'Take a training course',
        textContent: 'Avalara University has free, self-paced training courses for every step of your AvaTax journey. Sign up for live workshops led by expert instructors or watch recorded sessions later.',
        buttonText: 'Browse courses',
        link: 'https://training.avalara.com/',
    },
    {
        title: 'Find customized help',
        textContent: 'Visit the Avalara Help Center to follow along with detailed instructions for setting up AvaTax and connecting it to your business application.',
        buttonText: 'Get started',
        link: 'https://help.avalara.com/FYHP',
    },
];
